import React, { useState } from "react";
import { Container } from "reactstrap";

import PlanFaqs from "../pricing/plan-faqs";
import ContactForm from "../generic/contact-form";
import { connectWithUs } from "@/utils/content";
import { connectWithUsEmailService } from "@/services/connectWithUsServices";
import useAlertBar from "@/hooks/useAlertBar";

const ConnectWithUs = () => {
  const content = connectWithUs.en;
  const { openAlertBar } = useAlertBar();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (data: any) => {
    setLoading(true);

    const requestData = { ...data };
    requestData.carriers = requestData.carriers
      .filter((item: any) => typeof item === "string")
      .join(", ");

    try {
      let res = await connectWithUsEmailService(requestData);

      if (res.data.status) {
        setLoading(false);
        openAlertBar(res.data.message, true);
      } else {
        setLoading(false);
        openAlertBar("Error occurred while sending your request", false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      openAlertBar("Error occurred while sending your request", false);
    }
  };

  return (
    <Container>
      <div className="text-center">
        <h1 className="my-5">{content.title}</h1>
        <h5 className="my-3">
          {content.subTitle1} {content.subTitle2}
        </h5>
      </div>
      <ContactForm submitHandler={handleSubmit} loading={loading} />
      {/* <PlanFeatures data={undefined} /> */}
      <PlanFaqs />
    </Container>
  );
};

export default ConnectWithUs;
